export default {
  buttons: {
    reschedule: 'Reagendar',
    'reschedule-change-address': 'Reagendar/Alterar morada',
    'add-time': 'Adicionar hora',
  },
  'pickup-time-min-title': 'Hora de recolha mín.',
  'pickup-time-max-title': 'Hora de recolha máx.',
  'pickup-date': 'Escolha uma data de entrega',
  'change-address': {
    title: 'Alterou a sua morada',
    description: 'Dê-nos algum tempo para processar a sua encomenda; enviaremos a ligação de acompanhamento.',
    error: 'Lamentamos, não entregamos na morada selecionada. Introduza outra morada.',
  },
  'coolbox-modal': {
    message: 'O seu medicamento tem uma restrição de entrega sensível ao tempo.<br>Tem a certeza de que quer reagendar a data de entrega?',
    rescheduleButton: 'Sim, reagendar',
    cancelButton: 'Cancelar',
  },
  'next-day-window': 'Dia seguinte 8:00–21:00',
}
